import React, { useEffect, useState } from "react";
import { IQuestionOption } from "../../../types/questionOption";
import useCreateQuestionOption from "../../../hooks/question-options/useCreateQuestionOption";
import useDeleteQuestionOption from "../../../hooks/question-options/useDeleteQuestionOption";
import useUpdateQuestionOption from "../../../hooks/question-options/useUpdateQuestionOption";
// import { ISection } from '../../../../types/section';
// import useUpdateSection from '../../../../hooks/section/useUpdateSection';
// import useCreateSection from '../../../../hooks/section/useCreateSection';
// import useDeleteSection from '../../../../hooks/section/useDeleteSection';

interface IQuestionOptionProps {
  currOption: number[];
  setCurrOption: React.Dispatch<React.SetStateAction<number[]>>;
  questionOptions: IQuestionOption[];
  isDelete: boolean;
  setIsDelete: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const QuestionOption = ({
  currOption,
  setCurrOption,
  questionOptions,
  isDelete,
  setIsDelete,
  setIsOpenDeleteModal,
}: IQuestionOptionProps) => {
  const questionOptionId = currOption[0] || 0;
  const [questionOption, setQuestionOption] = useState(questionOptions[0]);
  const [type, setType] = useState<string>("");
  const [isProcessRunning, setIsProcessRunning] = useState<boolean>(false);
  const [isServiceError, setIsServiceError] = useState<string | null>(null); //eslint-disable-line

  const blankQuestionOption: IQuestionOption = {
    type: "",
    options: [],
  };

  useEffect(() => {
    if (questionOptionId === questionOptions.length) {
      setQuestionOption({ ...blankQuestionOption });
      setType("New question option");
    } else {
      setQuestionOption(questionOptions[questionOptionId]);
      setType(questionOptions[questionOptionId].type);
    }
  }, [questionOptionId, questionOptions]); //eslint-disable-line

  const { mutate: updateQuestionOption } = useUpdateQuestionOption({
    setIsProcessRunning,
    setIsServiceError,
  });
  const { mutate: createQuestionOption } = useCreateQuestionOption({
    setIsProcessRunning,
    setIsServiceError,
  });
  const { mutate: deleteQuestionOption } = useDeleteQuestionOption({
    setIsProcessRunning,
    setIsServiceError,
  });

  useEffect(() => {
    if (isDelete) {
      setCurrOption([0]);
      if (questionOption.id) deleteQuestionOption(questionOption.id);
      setIsDelete(false);
    }
  }, [isDelete]); //eslint-disable-line

  if (!questionOption) {
    return <p>Loading...</p>;
  }

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();

    if (questionOptionId === questionOptions.length) {
      createQuestionOption(questionOption.type);
    } else {
      if (type !== questionOption.type && questionOption.type !== "")
        updateQuestionOption(questionOption);
    }
    setType(questionOption.type);
  };

  const handleDelete = () => {
    if (questionOptionId === questionOptions.length) {
      setCurrOption([0]);
      setQuestionOption(questionOptions[questionOptionId]);
    } else {
      setIsOpenDeleteModal(true);
    }
  };

  return (
    <div className="imm_quest_admin__content">
      <div className="content_head">
        <h3>{type}</h3>
      </div>

      <form onSubmit={handleSave} className="content_form">
        <div className="field">
          <label htmlFor="title">Type</label>
          <input
            id="type"
            name="type"
            placeholder="Enter type"
            value={questionOption.type}
            onChange={(e) =>
              setQuestionOption({ ...questionOption, type: e.target.value })
            }
          />
        </div>

        <div className="actions">
          <button className="delete_btn" type="button" onClick={handleDelete}>
            {isProcessRunning ? (
              <i className="imm_quest_admin__process_loader" />
            ) : questionOptionId === questionOptions.length ? (
              "Cancel"
            ) : (
              "Delete"
            )}
          </button>
          <button className="save_btn" type="submit">
            {isProcessRunning ? (
              <i className="imm_quest_admin__process_loader" />
            ) : questionOptionId === questionOptions.length ? (
              "Create"
            ) : (
              "Save"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default QuestionOption;
